import type { TalkingPointDto, TopicDto } from '../api/generated/client';
import type { IPanelProps } from '../components/topic/panels/TopicPanel';
import { PRIMARY_NAVIGATION_BAR_HEIGHT } from '../config/constants';
import type { AdvisoryNeedDto } from '../interfaces/advisory-need';

export const GRID_GAP = 16;
export const PADDING_X = 24;
export const PADDING_Y = 20;
export const TITLE_HEIGHT = 32;
export const CLIENT_INFO_HEIGHT = PRIMARY_NAVIGATION_BAR_HEIGHT;
export const GRID_COLUMNS = 4;
export const DIALOG_PADDING_X = 24;
export const DIALOG_BORDER_Y = 1;
export const DIALOG_GRID_PADDING = 0;

/* Grid layout for Topic tiles functions */
export const getTileHeight = (height: number, isPresentationMode: boolean) => {
    const offset = getClientBarHeight(isPresentationMode);
    const gapNum = getNumberOfRowGaps(isPresentationMode);

    return getMaxTileHeight(height, gapNum, offset);
};

export const getClientBarHeight = (isPresentationMode: boolean) => (isPresentationMode ? CLIENT_INFO_HEIGHT + TITLE_HEIGHT : CLIENT_INFO_HEIGHT);

export const getNumberOfRowGaps = (isPresentationMode: boolean) => (isPresentationMode ? 3 : 2);

export const getMaxTileWidth = (width: number) => (width - (GRID_COLUMNS - 1) * GRID_GAP - PADDING_X * 2) / GRID_COLUMNS;

export const getMaxTileHeight = (height: number, numberOfRowGaps: number, clientBarHeight: number) =>
    (height - GRID_GAP * numberOfRowGaps - PADDING_Y * 2 - clientBarHeight) / 2;

export const getMaxDialogTileWidth = (width: number) =>
    (width - DIALOG_BORDER_Y * 2 - (GRID_COLUMNS - 1) * GRID_GAP - DIALOG_GRID_PADDING * 2 - DIALOG_PADDING_X * 2) / GRID_COLUMNS;

export const getMaxDialogTileHeight = (width: number, aspectRatio: number) => getMaxDialogTileWidth(width) * aspectRatio;

/* Topic panel */
export const buildPanelProps = (
    topic: TopicDto,
    containerDimensionsHeight: number,
    activeTalkingPoint?: TalkingPointDto,
    activeAdvisoryNeed?: AdvisoryNeedDto,
    isPresentationMode?: boolean,
    showBackButton?: boolean,
): IPanelProps => ({
    isKeyQuestionSelected: !!activeTalkingPoint,
    isAdvNeedSelected: !!activeAdvisoryNeed,
    isPresentationMode,
    containerDimensionsHeight,
    showBackButton,
    topic,
});
